import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_CHEVRON_RIGHT: GlameraIconDefinition = {
  name: 'circle-chevron-right',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-chevron-right-circle" cx="12" cy="12" r="10"></circle>
    <path class="glm-circle-chevron-right-arrow" d="m10 8 4 4-4 4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-chevron-right-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-chevron-right.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleChevronRightIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_CHEVRON_RIGHT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
